import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordResetConfirm.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordResetConfirm.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/confirpassreset/PasswordResetConfirm.vue?vue&type=script&lang=js
// module id = 1nR1
// module chunks = 41